import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const GOVERNANCE_CONFIG_VIEWS_VOCABULARIES = [
    vocabulary('policy.scope', '@vello/api-client PolicyScope', {
        platform: L('Plataforma', 'Platform', 'Plataforma', 'Piattaforma'),
        country: L('País', 'Country', 'País', 'Paese'),
        region: L('Estado', 'State', 'Estado', 'Regione'),
        market: L('Mercado', 'Market', 'Mercado', 'Mercato'),
        category: L('Categoria de serviço', 'Service category', 'Categoría de servicio', 'Categoria di servizio'),
        geofence: L('Geocerca', 'Geofence', 'Geocerca', 'Geofence'),
        campaign: L('Campanha', 'Campaign', 'Campaña', 'Campagna'),
    }),
    vocabulary('policy.override_mode', '@vello/api-client OverrideMode', {
        FIXED: L('Fixo', 'Fixed', 'Fijo', 'Fisso'),
        TIGHTEN_ONLY: L('Só pode ficar mais restrito', 'Can only be tightened', 'Solo puede endurecerse', 'Può solo essere inasprito'),
        OVERRIDABLE: L('Pode ser substituído', 'Can be overridden', 'Puede sustituirse', 'Può essere sostituito'),
        ADDITIVE: L('Pode receber acréscimos', 'Can be added to', 'Admite adiciones', 'Può essere integrato'),
        SELECT_PROVIDER: L('Escolhe o provedor', 'Provider is chosen', 'Se elige el proveedor', 'Si sceglie il fornitore'),
    }),
    vocabulary('policy.constraint_class', '@vello/api-client ConstraintClass', {
        legal: L('Legal', 'Legal', 'Legal', 'Legale'),
        safety: L('Segurança', 'Safety', 'Seguridad', 'Sicurezza'),
        privacy: L('Privacidade', 'Privacy', 'Privacidad', 'Privacy'),
        tax: L('Fiscal', 'Tax', 'Fiscal', 'Fiscale'),
        ledger: L('Contábil', 'Accounting', 'Contable', 'Contabile'),
        eligibility: L('Elegibilidade', 'Eligibility', 'Elegibilidad', 'Idoneità'),
        payment: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
    }),
    vocabulary('country_pack.status', '@vello/api-client CountryPackStatus', {
        DRAFT: L('Rascunho', 'Draft', 'Borrador', 'Bozza'),
        APPROVED: L('Aprovado', 'Approved', 'Aprobado', 'Approvato'),
        RETIRED: L('Retirado', 'Retired', 'Retirado', 'Ritirato'),
    }),
    vocabulary('country_pack.retire_reason', '@vello/api-client COUNTRY_PACK_RETIRE_REASON_CODES', {
        pack_country_exit: L('Saída do país', 'Leaving the country', 'Salida del país', 'Uscita dal paese'),
        pack_registered_in_error: L('Cadastrado por engano', 'Registered in error', 'Registrado por error', 'Registrato per errore'),
        pack_test_registration: L('Cadastro de teste', 'Test registration', 'Registro de prueba', 'Registrazione di prova'),
        pack_superseded: L('Substituído por outra versão', 'Superseded by another version', 'Sustituido por otra versión', 'Sostituito da un’altra versione'),
        pack_other: L('Outro motivo', 'Other reason', 'Otro motivo', 'Altro motivo'),
    }),
    vocabulary('market.launch_status', '@vello/api-client MarketLaunchStatus', {
        DRAFT: L('Rascunho', 'Draft', 'Borrador', 'Bozza'),
        CONFIGURING: L('Em configuração', 'Being configured', 'En configuración', 'In configurazione'),
        PILOT: L('Piloto', 'Pilot', 'Piloto', 'Pilota'),
        ACTIVE: L('Ativo', 'Active', 'Activo', 'Attivo'),
        PAUSED: L('Pausado', 'Paused', 'Pausado', 'In pausa'),
        EXITING: L('Em encerramento', 'Winding down', 'En cierre', 'In chiusura'),
        RETIRED: L('Encerrado', 'Retired', 'Cerrado', 'Chiuso'),
    }),
    vocabulary('market.status_reason', '@vello/api-client MARKET_STATUS_REASON_CODES', {
        market_launch_approved: L('Lançamento aprovado', 'Launch approved', 'Lanzamiento aprobado', 'Lancio approvato'),
        market_pilot_extended: L('Piloto estendido', 'Pilot extended', 'Piloto extendido', 'Pilota esteso'),
        market_paused_by_operations: L('Pausado pela operação', 'Paused by operations', 'Pausado por la operación', 'Sospeso dalle operazioni'),
        market_regulatory_hold: L('Retenção regulatória', 'Regulatory hold', 'Retención regulatoria', 'Blocco regolatorio'),
        market_retired_end_of_service: L('Fim do serviço', 'End of service', 'Fin del servicio', 'Fine del servizio'),
        market_other: L('Outro motivo', 'Other reason', 'Otro motivo', 'Altro motivo'),
    }),
    vocabulary('settings.origin', '@vello/api-client GovernedSettingOrigin', {
        GOVERNED: L('Governada', 'Governed', 'Gobernada', 'Governata'),
        LEGACY: L('Legada', 'Legacy', 'Heredada', 'Legacy'),
        ATTESTED: L('Atestada', 'Attested', 'Atestada', 'Attestata'),
        UNVERIFIED: L('Não verificada', 'Unverified', 'No verificada', 'Non verificata'),
    }),
    vocabulary('settings.change_status', '@vello/api-client GovernedChangeStatus', {
        PENDING_APPROVAL: L('Aguardando aprovação', 'Awaiting approval', 'Esperando aprobación', 'In attesa di approvazione'),
        APPLIED: L('Aplicada', 'Applied', 'Aplicada', 'Applicata'),
        REJECTED: L('Rejeitada', 'Rejected', 'Rechazada', 'Rifiutata'),
        WITHDRAWN: L('Retirada', 'Withdrawn', 'Retirada', 'Ritirata'),
        SUPERSEDED: L('Substituída', 'Superseded', 'Sustituida', 'Sostituita'),
    }),
    vocabulary('operator.scope_kind', '@vello/api-client OperatorScopeKind; ManagedScopeType', {
        GLOBAL: L('Global', 'Global', 'Global', 'Globale'),
        COUNTRY: L('País', 'Country', 'País', 'Paese'),
        REGION: L('Estado', 'State', 'Estado', 'Regione'),
        CITY: L('Cidade', 'City', 'Ciudad', 'Città'),
        MARKET: L('Mercado', 'Market', 'Mercado', 'Mercato'),
        MERCHANT: L('Loja', 'Merchant', 'Comercio', 'Esercente'),
        FLEET: L('Frota', 'Fleet', 'Flota', 'Flotta'),
        PARTNER: L('Parceiro', 'Partner', 'Socio', 'Partner'),
    }),
];
//# sourceMappingURL=governance-config-views.js.map